import { supabase } from '@/integrations/supabase/client';
import { purgeDeviceProgressState } from '@/lib/deviceProgressState';


export const PLAYER_LOGIN_KEY = 'sportara_player_login';

/** Username to pre-fill on the player login screen, from storage or the URL. */
export function pendingPlayerLoginUsername(): string {
  try {
    const stored = localStorage.getItem(PLAYER_LOGIN_KEY);
    if (stored) return stored;
  } catch { /* ignore */ }
  try {
    return new URLSearchParams(window.location.search).get('player') || '';
  } catch {
    return '';
  }
}

export function clearPendingPlayerLogin() {
  try { localStorage.removeItem(PLAYER_LOGIN_KEY); } catch { /* ignore */ }
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.has('player')) {
      url.searchParams.delete('player');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }
  } catch { /* ignore */ }
}

/**
 * Hands the device to a child account. The parent session is ended and the app
 * reloads straight onto the player PIN screen — the `?player=` param keeps the
 * intent through the reload so we never bounce off to the landing page.
 */
export async function switchToChildAccount(username: string) {
  try { await supabase.auth.signOut(); } catch { /* ignore */ }
  // Drop every device-local learning key from the outgoing account before the
  // child's session starts, so nothing carries over on a shared device.
  purgeDeviceProgressState();
  try { localStorage.setItem(PLAYER_LOGIN_KEY, username); } catch { /* ignore */ }
  window.location.replace(`/?player=${encodeURIComponent(username)}`);
}

